import {Component, OnInit} from '@angular/core';
import {GeneralCapacityComponent} from '../general-capacity/general-capacity.component';
import {CommonModule} from '@angular/common';
import {animate, style, transition, trigger} from '@angular/animations';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-capacity',
  templateUrl: './dashboard-capacity.component.html',
  styleUrls: ['./dashboard-capacity.component.scss'],
  standalone: true,
  imports: [
    GeneralCapacityComponent,
    CommonModule,
    TranslateModule
  ],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('500ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        )
      ])
    ])
  ]
})
export class DashboardCapacityComponent implements OnInit {
  capacities: any[] = [];
  userRole: string = '';
  logoUrl: string = 'assets/images/axede-logo.png'; // Add the logo to this path

  ngOnInit() {
    this.getRole();
    this.capacities = this.getFilteredCapacities();
  }

  getRole() {
    const user: any = JSON.parse(localStorage.getItem('logged_in_agent') ?? '{}');
    this.userRole = user.role || 'agent'; // Default to agent if no role is found
  }

  private getFilteredCapacities() {
    const allCapacities = [
      {
        title: 'layout.capacity.agents.title',
        description: 'layout.capacity.agents.desc',
        icon: 'pi pi-users',
        link: '/agent-layout',
        roles: ['agent', 'supervisor', 'admin', 'superadmin']
      },
      {
        title: 'layout.capacity.supervisor.title',
        description: 'layout.capacity.supervisor.desc',
        icon: 'pi pi-user-edit',
        link: '/supervisor',
        roles: ['admin', 'supervisor', 'superadmin']
      },
      // {
      //   title: 'Administrador',
      //   description: 'Configuración completa del Contact Center',
      //   icon: 'pi pi-cog',
      //   link: '/admin',
      //   roles: ['admin', 'superadmin']
      // },
      // {
      //   title: 'Integración CRM',
      //   description: 'Conecte sus sistemas CRM para datos unificados',
      //   icon: 'pi pi-database',
      //   link: '/crm-integration',
      //   roles: ['agent', 'supervisor', 'admin', 'superadmin']
      // },
      // {
      //   title: 'Soporte y Entrenamiento',
      //   description: 'Recursos para mejorar su experiencia en la plataforma',
      //   icon: 'pi pi-book',
      //   link: '/support-training',
      //   roles: ['agent', 'supervisor', 'admin', 'superadmin']
      // },
      // {
      //   title: 'Dashboard y Reportes',
      //   description: 'Analíticas y métricas de rendimiento',
      //   icon: 'pi pi-chart-line',
      //   link: '/dashboard',
      //   roles: ['supervisor', 'admin', 'superadmin']
      // },
      {
        title: 'layout.capacity.settings.title',
        description: 'layout.capacity.settings.desc',
        icon: 'pi pi-sliders-h',
        link: '/settings',
        roles: ['agent', 'supervisor', 'admin', 'superadmin']
      }
    ];

    return allCapacities.filter(item => item.roles.includes(this.userRole));
  }
}
